// NOOVI: helpers compartilhados pelos filtros do Pipeline.
// Trata 0 como valor definido (value_min/max = 0 é um filtro válido).
export const isSet = v => v !== null && v !== undefined && v !== '';

// 'YYYY-MM-DD' parseado como meia-noite LOCAL — new Date('YYYY-MM-DD') é UTC
// midnight pela spec e recua 1 dia em fusos negativos (BRT): o resumo de
// filtros mostrava "31/05" para um filtro salvo de 01/06 (QA ciclo 9).
export const parseDateOnlyLocal = value => {
  if (typeof value === 'string') {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    }
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};
